import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row m-4 mt-0"
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0 text-center text-muted py-3" }
const _hoisted_4 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = { class: "card card-body mb-3" }
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 1,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_13 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_14 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_15 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_16 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_17 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_18 = {
  key: 2,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_19 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_20 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "form-group mb-2 col" }
const _hoisted_23 = { class: "col-auto p-0 text-end" }
const _hoisted_24 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_25 = { class: "col-sm-12" }
const _hoisted_26 = { class: "card card-body mb-0" }
const _hoisted_27 = { class: "overflow-auto" }
const _hoisted_28 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative mb-0" }
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "text-capitalize-first text-end" }
const _hoisted_31 = { class: "text-capitalize-first text-end" }
const _hoisted_32 = { class: "text-capitalize-first text-end" }
const _hoisted_33 = { class: "text-capitalize-first text-end" }
const _hoisted_34 = { class: "text-capitalize-first text-end" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "d-inline-flex align-items-center gap-2" }
const _hoisted_37 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  colspan: "7",
  class: "p-0 bg-light"
}
const _hoisted_55 = { class: "p-3" }
const _hoisted_56 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_59 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_60 = { class: "table table-striped border-light align-middle text-left text-nowrap bg-white mb-0" }
const _hoisted_61 = { class: "text-capitalize-first" }
const _hoisted_62 = { class: "text-capitalize-first" }
const _hoisted_63 = { class: "text-capitalize-first" }
const _hoisted_64 = { class: "text-capitalize-first" }
const _hoisted_65 = { class: "text-capitalize-first" }
const _hoisted_66 = { class: "text-capitalize-first" }
const _hoisted_67 = ["title"]
const _hoisted_68 = {
  key: 0,
  class: "badge bg-danger ms-1"
}
const _hoisted_69 = { class: "text-end" }
const _hoisted_70 = { class: "dropdown" }
const _hoisted_71 = {
  type: "button",
  class: "btn btn-sm btn-outline-dark",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_72 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  colspan: 7,
  class: "text-center text-muted py-3"
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  colspan: "7",
  class: "text-center text-muted py-4"
}
const _hoisted_80 = { class: "mb-2" }
const _hoisted_81 = { class: "form-label text-capitalize-first" }
const _hoisted_82 = { class: "mb-2" }
const _hoisted_83 = { class: "form-label text-capitalize-first" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_CounterpartyStatisticsDetailsModal = _resolveComponent("CounterpartyStatisticsDetailsModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_ReattachRequisiteModal = _resolveComponent("ReattachRequisiteModal")!
  const _component_CounterpartiesImportModal = _resolveComponent("CounterpartiesImportModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!
  const _directive_bs_dropdown_fixed = _resolveDirective("bs-dropdown-fixed")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      (_ctx.accessDeniedByApi)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.helper.trans('statistic.counterparties.access_denied')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.id) = $event)),
                            placeholder: _ctx.helper.trans('labels.id'),
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]), ["enter"]))
                          }, null, 40, _hoisted_9), [
                            [_vModelText, _ctx.requestDTO.id]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.query) = $event)),
                            placeholder: _ctx.helper.trans('labels.requisites'),
                            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]), ["enter"]))
                          }, null, 40, _hoisted_11), [
                            [_vModelText, _ctx.requestDTO.query]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Multiselect, {
                        id: "cp-filter-currencies",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.currencies,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.currencies) = $event)),
                        options: _ctx.currencyList,
                        "custom-label": (opt) => `${opt}`,
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.currencies')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Multiselect, {
                        id: "cp-filter-methods",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.methods,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
                        options: _ctx.methodList(),
                        "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.payment_methods')
                      }, {
                        option: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_PayMethodIcon, {
                              "icon-class": "icon",
                              method: props.option
                            }, null, 8, ["method"]),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Multiselect, {
                        id: "cp-filter-options",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.options,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
                        options: _ctx.paymentOptions,
                        "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.payment_options')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Multiselect, {
                        id: "cp-filter-statuses",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.statuses,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                        options: [1, 0],
                        "custom-label": (opt) => (opt === 1 ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive')),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.status')
                      }, null, 8, ["modelValue", "custom-label", "placeholder"])
                    ]),
                    (_ctx.isOperator || _ctx.isAdmin || _ctx.isTeamLead)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_TraderMultiselect, {
                            multiple: true,
                            modelValue: _ctx.tradersFilter,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tradersFilter) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_StoreMultiselect, {
                        multiple: false,
                        modelValue: _ctx.filterStore,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterStore) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestDTO.counterpartyUserId) = $event)),
                        placeholder: _ctx.helper.trans('labels.user_id'),
                        autocomplete: "off",
                        onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]), ["enter"]))
                      }, null, 40, _hoisted_21), [
                        [
                          _vModelText,
                          _ctx.requestDTO.counterpartyUserId,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"])),
                          class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)), ["prevent"])),
                          class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("table", _hoisted_28, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("th", { style: {"width":"0"} }, null, -1)),
                          _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('statistic.counterparties.profile')), 1),
                          _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.helper.trans('statistic.counterparties.profile_total_amount')), 1),
                          _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.helper.trans('statistic.counterparties.profile_average_check')), 1),
                          _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans('statistic.counterparties.profile_avg_traffic_24h')), 1),
                          _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.helper.trans('statistic.counterparties.profile_deals')), 1),
                          _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans('statistic.counterparties.profile_days_in_work')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requisites.items, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: item.id
                          }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-link p-0",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleExpand(item.id)), ["prevent"])
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa-solid", _ctx.isExpanded(item.id) ? 'fa-chevron-up' : 'fa-chevron-down'])
                                  }, null, 2)
                                ], 8, _hoisted_35)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_36, [
                                  _createVNode(_component_PayMethodIcon, {
                                    method: item.method
                                  }, null, 8, ["method"]),
                                  _createElementVNode("span", null, "#" + _toDisplayString(item.id), 1),
                                  (item.requisites)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(item.requisites), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_38, [
                                (_ctx.profileLoading[item.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, "…"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.formatProfileTotalAmount(item.id, item.currency)), 1))
                              ]),
                              _createElementVNode("td", _hoisted_41, [
                                (_ctx.profileLoading[item.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "…"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.formatProfileAverageCheck(item.id)), 1))
                              ]),
                              _createElementVNode("td", _hoisted_44, [
                                (_ctx.profileLoading[item.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, "…"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.formatProfileAvgTraffic24h(item)), 1))
                              ]),
                              _createElementVNode("td", _hoisted_47, [
                                (_ctx.profileLoading[item.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "…"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.formatProfileDeals(item.id)), 1))
                              ]),
                              _createElementVNode("td", _hoisted_50, [
                                (_ctx.profileLoading[item.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, "…"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.formatProfileDaysInWork(item.id)), 1))
                              ])
                            ]),
                            (_ctx.isExpanded(item.id))
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                                  _createElementVNode("td", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-outline-primary btn-sm text-capitalize-first",
                                          onClick: _withModifiers(($event: any) => (_ctx.openAttach(item)), ["prevent"])
                                        }, _toDisplayString(_ctx.helper.trans('statistic.counterparties.attach')), 9, _hoisted_57)
                                      ]),
                                      (_ctx.expandLoading[item.id])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.helper.trans('requisites_capacity.loading')), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            _createElementVNode("table", _hoisted_60, [
                                              _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                  _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.helper.trans('statistic.counterparties.counterparty_id')), 1),
                                                  _createElementVNode("th", _hoisted_62, _toDisplayString(_ctx.helper.trans('statistic.counterparties.sent')), 1),
                                                  _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.helper.trans('labels.average_check')), 1),
                                                  _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.helper.trans('labels.conversion_rate')), 1),
                                                  _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.helper.trans('labels.total_completed')), 1),
                                                  _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.helper.trans('labels.last_used_at')), 1),
                                                  _cache[22] || (_cache[22] = _createElementVNode("th", null, null, -1))
                                                ])
                                              ]),
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCounterparties(item.id), (cp, cpIndex) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: `${cp.userId}-${cpIndex}`
                                                  }, [
                                                    _createElementVNode("td", null, [
                                                      _withDirectives((_openBlock(), _createElementBlock("span", {
                                                        title: cp.userId
                                                      }, [
                                                        _createTextVNode(_toDisplayString(cp.userId), 1)
                                                      ], 8, _hoisted_67)), [
                                                        [
                                                          _directive_b_tooltip,
                                                          void 0,
                                                          void 0,
                                                          { hover: true }
                                                        ]
                                                      ]),
                                                      (cp.isBanned)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.helper.trans('labels.banned')), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatSent(cp)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(Number.parseFloat(cp.averageCheck || '0'), 2)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatConversion(cp)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(cp.totalCompleted ?? cp.completedCount)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatLastUsedAt(cp.lastUsedAt)), 1),
                                                    _createElementVNode("td", _hoisted_69, [
                                                      _createElementVNode("div", _hoisted_70, [
                                                        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_71, _cache[23] || (_cache[23] = [
                                                          _createElementVNode("i", { class: "fa-solid fa-ellipsis" }, null, -1)
                                                        ]))), [
                                                          [_directive_bs_dropdown_fixed]
                                                        ]),
                                                        _createElementVNode("ul", _hoisted_72, [
                                                          _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                              href: "#",
                                                              class: "dropdown-item",
                                                              onClick: _withModifiers(($event: any) => (_ctx.viewStats(cp)), ["prevent"])
                                                            }, [
                                                              _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fa fa-eye me-2" }, null, -1)),
                                                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.counterparties.menu_view_stats')), 1)
                                                            ], 8, _hoisted_73)
                                                          ]),
                                                          _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                              href: "#",
                                                              class: "dropdown-item",
                                                              onClick: _withModifiers(($event: any) => (_ctx.startReattach(item.id, cp.userId)), ["prevent"])
                                                            }, [
                                                              _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fa fa-right-left me-2" }, null, -1)),
                                                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.counterparties.menu_reattach')), 1)
                                                            ], 8, _hoisted_74)
                                                          ]),
                                                          _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                              href: "#",
                                                              class: "dropdown-item text-danger",
                                                              onClick: _withModifiers(($event: any) => (_ctx.confirmUnlink(item.id, cp)), ["prevent"])
                                                            }, [
                                                              _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-trash me-2" }, null, -1)),
                                                              _createTextVNode(_toDisplayString(_ctx.helper.trans('statistic.counterparties.menu_unlink')), 1)
                                                            ], 8, _hoisted_75)
                                                          ])
                                                        ])
                                                      ])
                                                    ])
                                                  ]))
                                                }), 128)),
                                                (!_ctx.getCounterparties(item.id).length)
                                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                                                      _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        (!_ctx.requisites.items.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_78, [
                              _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.helper.trans('statistic.counterparties.no_requisites')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (_ctx.requisites.totalCount > _ctx.requisites.limit)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[14] || (_cache[14] = ($event: any) => ((_ctx.page) = $event)),
                          _ctx.loadRequisites
                        ],
                        "total-rows": _ctx.requisites.totalCount,
                        "per-page": _ctx.requisites.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        class: "mt-3",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64)),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('statistic.counterparties.attach'),
        modelValue: _ctx.attachModalVisible,
        "footer-class": "d-flex justify-content-end gap-2",
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.attachModalVisible = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.helper.trans('labels.stores')), 1),
            _createVNode(_component_StoreMultiselect, {
              multiple: false,
              modelValue: _ctx.attachStore,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.attachStore) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.helper.trans('labels.user_id')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.attachUserId) = $event)),
              type: "text",
              class: "form-control form-control-sm",
              autocomplete: "off"
            }, null, 512), [
              [
                _vModelText,
                _ctx.attachUserId,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm text-capitalize-first",
            disabled: !_ctx.attachStore,
            onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openImportForAttach && _ctx.openImportForAttach(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.helper.trans('statistic.counterparties.import_from_file')), 9, _hoisted_84)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm text-capitalize-first",
            onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeAttachModal && _ctx.closeAttachModal(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary btn-sm text-capitalize-first",
            disabled: !_ctx.attachUserId || !_ctx.attachStore,
            onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAttach && _ctx.submitAttach(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.helper.trans('button.save')), 9, _hoisted_85)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_CounterpartyStatisticsDetailsModal, { ref: "detailsModal" }, null, 512),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
      _createVNode(_component_ReattachRequisiteModal, {
        ref: "reattachModal",
        onSelected: _ctx.handleReattachSelected
      }, null, 8, ["onSelected"]),
      _createVNode(_component_CounterpartiesImportModal, {
        ref: "importModal",
        onImported: _ctx.onImported
      }, null, 8, ["onImported"])
    ]),
    _: 1
  }, 512))
}